import React,{ useState, useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import ReactLoading from 'react-loading';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";


import downloadOrder from "../functions/downloadOrder";
import recordDataOrder from "../functions/recordDataOrder";
import getDataExportPrice from "../functions/getDateExportPrice";
import downloadSample from "../functions/downloadSample";
import creditCheck from "../functions/doCreditCheck";


import Tools from './ExportToolsPaper';
import ProductCard from './DataProductCard';

//import {ReactComponent as DownloadIcon} from '../assets/icons/download.svg';
import GetAppIcon from '@material-ui/icons/GetApp';
import Collapse from "@material-ui/core/Collapse";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default function ExportPanel(props) {

  const useStyles = makeStyles((theme) => ({
    root: {
      width: props.width,
      minWidth: props.width,
      height: props.height - 30,
      overflowY: "auto",

      '& .MuiOutlinedInput-root':{
        height:30
      },
      '& .MuiAccordion-root:before':{
        top: 0
      },
      '& .MuiAccordion-root.Mui-expanded':{
        margin: 0
      },
      '& .MuiAccordionSummary-root':{
        color:'#fff',
        background:'#0C4C35',
        borderBottom: '1px solid #209A39'
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 30,
        borderBottom: '0px solid #3D3E4F',
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: 10
      },
      '& .MuiCheckbox-root': {
        paddingTop: 0,
        paddingBottom: 5,
        paddingRight: 5,
        paddingLeft: 0,
      },
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: '#63D764',
        paddingTop: 0,
        paddingBottom: 5,
        paddingRight: 5,
        paddingLeft: 0,
      },
      '& .MuiRadio-root': {
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 9,
      },
      '& .MuiRadio-colorSecondary.Mui-checked': {
        color: '#f50057',
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 9,
      },
      '& a': {
        color: '#0C4C35',
      }
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    sizecontainer:{
      marginLeft: 5,
    },
    container: {
      width: 300,
    },
    textField: {
      minWidth: 200,
      paddingRight:5,
      marginBottom:10,
    },
    exportLabel:{
      paddingBottom:10,
    },
    exportAreaLabel:{
      paddingTop:5,
      paddingBottom:2,
    },
    textItemFont:{
      fontSize:12
    },
    priceLabel: {
      paddingBottom:5,
    },
    textgridField:{
      paddingTop:2,
    },
    moreProductsButton: {
      marginTop: 0,
      marginLeft: 15,
      padding: 5,
      height: 20,
      textAlign: 'left',
      color: '#0C4C35',
      '&:hover': {
        color: '#63D764',
      },
    },
    priceTable:{
      paddingTop:10,
      paddingBottom:10,
    },
    purchaseButton:{
      width:'50%',
      height: 20,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    cancelButton:{
      width: '35%',
      height: 20,
      color: '#FFF',
      marginLeft: 10,
      backgroundColor: '#666',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    downloadButton:{
      width: 160,
      height: 40,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    closeMenuButton:{
      width: 60,
      height: 40,
      color: '#FFF',
      marginLeft: 10,
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    layersAccordionDetails:{
      padding: 0,
        margin: 0,
      marginRight: 30
    },
    layersSelection:{
      width: 305
    },
    productList:{
      width: 305,
      minHeight: 110,
      maxHeight: '22vh',
      overflowY: 'auto',
      overflowX: 'hidden',
      //maxHeight:props.height-345,
    },
    errorTxt:{
      color: '#cc0000',
      paddingBottom:5,
    },
    radioLabel:{
      fontSize:14,
    },
    confirmAreaButton:{
      width:260,
      height: 22,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    backButton: {
      textDecoration: 'underline',
    },
    downloadIcon: {
      height:16,
      width:16
    },

  }));

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [uState] = useContext(UserContext);
  const [vatRate, setVatRate] = useState(parseFloat(process.env.REACT_APP_VAT_RATE));
  const [dataArea, setDataArea] = useState('1ha');
  const [hasCustomTools, setHasCustomTools] = useState(false);
  const [hasMoreProducts, setHasMoreProducts] = useState(false);

  const [price, setPrice] = useState(0);
  const [vat, setVAT] = useState(0);
  const [total, setTotal] = useState(0);

  const [sampleProduct, setSampleProduct] = useState('');

  const [layersdisabled, setLayersdisabled] = useState(true);
  const [confirmAreadisabled, setConfirmAreadisabled] = useState(true);
  const [downloaddisabled, setDownloaddisabled] = useState(true);

  const [hasData, setHasData] = useState(true);
  const [hasLayer, setHasLayer] = useState(false);
  const [hasDownload, setHasDownload] = useState(false);
  const [hasCheckout, setHasCheckout] = useState(true);

  const [orderID, setOrderID] = useState(0);
  const [isProcess, setIsProcess] = useState(true);
  const [orderStatus, setOrderStatus] = useState('');
  const [doPoll, setDoPoll] = useState(false);
  const [pollTimer, setPollTimer] = useState(null);

  //Export data product list.
  const [dataProducts, setDataProducts] = useState([]);
  const [storedProducts, setStoredProducts] = useState([]);
  const [exportArea, setExportArea] = useState([]);

  //Enables / disableds the purchase button.
  const [purchaseDisabled, setPurchaseDisabled] = useState(true);

  const [projectReference, setProjectReference] = useState(sState.projectreference);
  const [hasPRError, setHasPRError] = useState(false);
  const [poNumber, setPoNumber] = useState(sState.userreference);
  const [hasPriceError, setHasPriceError] = useState(false);
  const [hasDownloadError, sethasDownloadError] = useState(false);

  const [purchaseTooltip, setPurchaseTooltip] = useState('Please select at least one data product to purchase your data export.');

  const allowedPattern = /^[a-zA-Z0-9_#$@%&-/(), ]*$/;
  
  /**
   * Loads the data export layer list options.
   * If not first time, compares current list  
   */
  useEffect(() => {
    const currentList = sState.exportListPrice;
    if (storedProducts.length > 0){
      storedProducts.forEach(function (d) {
        if (d.selected === true){
          currentList.forEach(function (c) {
            if (parseInt(d.productid) === parseInt(c.productid)){
              c.selected = true;
            }
          });
        }
      });
      // NOTE: this was wiping out the total price calculation when modifying the area
      //       ... seems to work still without doing it
      //setStoredProducts([]);
    }
    else {
      // Set default product (Mastermap) if available and nothing else selected yet
      currentList.forEach(function (c) {
        if (parseInt(c.productid) === 1) {
          //c.selected = true;

          switch(uState.company.companytype){
            case "standard_dxf":
              c.selectedFormat = "dxf";
              break;
            case "standard_shp":
              c.selectedFormat = "shp";
              break;
          }
          
        }
      });
    }
    if (uState.company.companytype == 'training') { setPurchaseTooltip('Select to download a sample data export.') };
    setDataProducts(currentList);
  },[sState.exportListPrice]);


  /**
   * On change of the required data area post change.
   * Starting point for data orders.
   */
  useEffect(() => {
        const d = {
          fixedsize: dataArea,
        }
        sDispatch({
          type: "setdata",
          payload: { data: d}
        });

        // Automatically confirm the export area
      handleConfirmExportArea()

  },[dataArea]);


  const handleDataAreaChange = (event) => {
    setDataArea(event.target.value);

    if (event.target.value === 'custom'){
      setHasCustomTools(true);
    } else {
      setHasCustomTools(false);
    }
  };

  /**
   * Listens project reference changes. 
   */
  useEffect(() => {
    sDispatch({ type: "setreference", payload: { projectreference: projectReference, userreference:poNumber} });
  },[projectReference, poNumber]);



  /**
   * Listens from mapobjects to see if a data export area has been drawn. 
   */
  useEffect(() => {
    if (sState.datageom.area > 0){
      setConfirmAreadisabled(false);
    } else {
      setConfirmAreadisabled(true);
      // Don't disable layers accordion when closing export tool
      //setHasLayer(false);
      //setLayersdisabled(true);
    };
    const a = parseFloat(sState.datageom.area) * 0.0001;
    
    setExportArea("Area selected:  "+a.toFixed(2).toString()+"Ha");

    if (hasLayer){ //If prices are shown update.
      const displayedList = JSON.parse(JSON.stringify(dataProducts));
      setStoredProducts(displayedList);

      getDataPrices();
    }
  },[sState.datageom]);

  /**
   * Updates pricing if layer list changes.
   */
  useEffect(() => {
    if (hasLayer){ //If prices are shown update.
      calculateOrderPrice(dataProducts);
    }
  },[dataProducts]);

  /**
   * Calculates the total order price
   */
  const calculateOrderPrice = (list) => {
    let oPrice = 0;
    let bSelected = true; 
    list.forEach(function (d) {
      if (d.selected === true){
        oPrice += parseFloat(d.price);
        bSelected = false;
      }
    });
    setPurchaseDisabled(bSelected);
    if (!bSelected) {
      setPurchaseTooltip('Select to purchase your data export.');
      if (uState.company.companytype == 'training') { setPurchaseTooltip('Select to download a sample data export.') };
    } else {
      setPurchaseTooltip('Please select at least one data product to purchase your data export.');
    }
  
    const dprice = parseFloat(oPrice).toFixed(2);
    const vprice = parseFloat(parseFloat(dprice/100) * parseFloat(vatRate)).toFixed(2);
    const tprice = parseFloat(parseFloat(dprice) + parseFloat(vprice)).toFixed(2);

    setPrice(dprice);
    setVAT(vprice);
    setTotal(tprice);
  }


  /**
   * Handles the order of the print.
   */
  const handlePurchase = async () => {

    let hasError = false;
    sethasDownloadError(false);
    
    if (projectReference.length <= 1 ){
      setHasPRError(true);
      hasError = true;
    } else {
      setHasPRError(false);
    }

    if (isNaN(price) || isNaN(vat)){
      setHasPriceError(true);
      hasError = true;
    } else {
      setHasPriceError(false);
    }

    const hasEnoughCredit = await creditCheck(sState.userid, uState.company.companycreditlimit, price, sDispatch);
    if (!hasError && hasEnoughCredit) {

      setHasData(false);
      setHasLayer(false);
      setHasCheckout(false);
      setHasDownload(true);
      setDownloaddisabled(false);
      setPurchaseDisabled(true);  

      //Stores the order transaction.       
      const dataPrice = {};
      dataPrice.price = price;
      dataPrice.vat = vat;
      dataPrice.total = total;
      
      let date = new Date();
      date.setMonth(date.getMonth() + 12);
      const day= ('0'+date.getDate()).slice(-2);
      const month = ('0'+(date.getMonth()+ 1)).slice(-2);
      const expiryDate = date.getFullYear()+'-'+ month +'-'+day;

      const prodOrder = [];
      dataProducts.forEach(function (d) {
        if (d.selected === true){
          
          prodOrder.push(d);
          if (uState.company.companytype == 'training') setSampleProduct(d.productcode+'_'+d.selectedFormat);
        }
      });

      if (uState.company.companytype == 'training') { 
        setDownloaddisabled(false);
        setIsProcess(false);
      } else {
        recordDataOrder(sState, dataPrice, prodOrder, '12 months', expiryDate, sDispatch, "ordered", uState.company.companytype);
      }

      //Clear screen
      sDispatch({ type: "setUserAction", payload: { action: "clearData" } });
    }
  };

  const cancelPurchase = () => {
    //Clear screen
    sDispatch({ type: "setUserAction", payload: { action: "endexport" } });
};

	/**
     * Tracks the response from the order request.
     * Gets the current orderid.
  */
  useEffect(() => {
    if (parseInt(sState.orderid) !== -1 && parseInt(sState.orderid) !== 0){
          setOrderID(sState.orderid);
          setOrderStatus("ordered");
      }
  },[sState.orderid])

    /**
     * Manages the monitoring
     */
  useEffect(() => {
      switch(orderStatus){
          case "ordered":
          case "processing":
              if (!doPoll){ setDoPoll(true); }
              if (!isProcess){ setIsProcess(true); }
              break;
          case "completed":
              if (doPoll){ setDoPoll(false); window.clearInterval(pollTimer);}
              if (isProcess){ setIsProcess(false); }
              break;
          default:
              break;
      }
  },[orderStatus])

  /**
   * Activates the order poll after order has been placed/
   */
  useEffect(() => {
      if (doPoll){
          pollOrderStatus();
      }
  },[doPoll])

  /**
   * Polls for order status.
  **/
  const pollOrderStatus = () => {

    let counter = 0;
    let timer = window.setInterval(function(){
      pollRequest();
      if (counter >= 60) { clearInterval(timer); sethasDownloadError(true); }
      counter++;
    }, 10000);
    setPollTimer(timer);


      const pollRequest = () => {
          //console.log("Poll orderid:"+orderID);
          if (doPoll){
          const abortController = new AbortController();
          const request = {   
              userid:sState.userid,
              orderid:orderID,
              sessionid:sState.ident,
          };

          let mounted = true;
          (async () => {
            const res = await fetch(process.env.REACT_APP_FIND_API+'/order/status', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(request),
              signal: abortController.signal,
            });
            const data = await res.json();
            if (mounted) {
              if (data.status === "success"){
                  if (data.orderStatus !== orderStatus){
                    //console.log("order id :"+orderID+" status:"+data.orderStatus);
                      setOrderStatus(data.orderStatus);
                  }
              }
            }
            const cleanup = () => {
              mounted = false;
              abortController.abort();
           };
           return cleanup;
          })();
      }; 
    }       
  };

  /**
    * Requests the download.
  */
    const handleFileDownload = (event) => {
    
      if (uState.company.companytype == 'training'){
        downloadSample(sampleProduct);
      } else {
        downloadOrder(orderID, sState.ident, sState.userid);
        sDispatch({ type: "setUserAction", payload: { action: "endexport" } });
        setIsProcess(false);
        setDownloaddisabled(true);
      }
  }

  /**
   * If the selection of item has changed.
   */
  const handleProductSelect = (productid, selected, format) => {
    const layerlist = JSON.parse(JSON.stringify(dataProducts));
  
    for (let d = 0; d < layerlist.length; d++) {
      if (parseInt(layerlist[d].productid) === parseInt(productid)){
        if (selected) { layerlist[d].selected = true;  } else { layerlist[d].selected = false; } 
        layerlist[d].selectedFormat = format;
        break;
      }
    }
    setDataProducts(layerlist);
    calculateOrderPrice(layerlist);
  }

  /**
   * Confirms the selected area.
   */
  const handleConfirmExportArea =()=>{
    getDataPrices();
    // NOTE: don't need to collapse this by default
    // setHasData(false);
    setHasLayer(true);
    setLayersdisabled(false);
  }

  const handleProjectReferenceChange = (e) => {
    const newProjectReference = e.target.value;
    if (allowedPattern.test(newProjectReference)) {
      setProjectReference(newProjectReference);
    }
  };

  const handlePONumberChange = (e) => {
    const newPONumber = e.target.value;
    if (allowedPattern.test(newPONumber)) {
      setPoNumber(newPONumber);
    }
  };

  const getDataPrices =()=>{
    const param = {
      fixedsize: dataArea,
      fixedprice: uState.default.ddatafixedprice,
    }
    getDataExportPrice(sState,  param, sDispatch,  uState.company.pricingid, uState.company.companytype);
  }

  const handleCloseDownload = () =>{
        setDoPoll(false); window.clearInterval(pollTimer);
        sDispatch({ type: "setUserAction", payload: { action: "endexport" } });
        setIsProcess(false);
        setDownloaddisabled(true);
  }

  /**
   * Goes back to define export area.
   */
  const handleDefineExportArea =()=>{
    setHasData(true);
    setHasLayer(false);
    setLayersdisabled(true);
  }
  
  return (
    <div className={classes.root}>
      <Accordion expanded={hasData} onChange={e => setHasData(!hasData)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Define your area</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box component="div" className={classes.container}>  
          <FormControl component="fieldset" className={classes.container}>
            <RadioGroup aria-label="dataarea" name="dataarea" className={classes.sizecontainer} value={dataArea} onChange={handleDataAreaChange}>
              <FormControlLabel value="1ha" classes={{ label: classes.radioLabel }} control={<Radio />} label="Fixed 1ha (100m x 100m)" />
              <FormControlLabel value="4ha" classes={{ label: classes.radioLabel }} control={<Radio />} label="Fixed 4ha (200m x 200m)" />
              <FormControlLabel value="custom" classes={{ label: classes.radioLabel }} control={<Radio />} label="Custom" />
            </RadioGroup>
          </FormControl>
            {hasCustomTools ? (<Box><Tools geometry={sState.datageom}/><Box className={classes.exportAreaLabel} fontSize={12}>{exportArea}</Box></Box>) : ( '' )}
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion disabled={layersdisabled} expanded={hasLayer} onChange={e => setHasLayer(!hasLayer)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Choose your data</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.layersAccordionDetails}>
        <Box className={classes.layersSelection}>
          <Box className={classes.productList}>
            <Box>
              {dataProducts.filter(item => item.productid === 1 || hasMoreProducts).map((item, i) =>
                  <ProductCard key={i} productid={item.productid} product={item.productname} disabled={item.hasData} formats={item.formats} defaultFormat={item.selectedFormat} price={item.price} tooltip={item.tooltip} selected={item.selected} handleSelect={handleProductSelect} />
              )}
            </Box>
            <Collapse in={!hasMoreProducts}>
              <Button className={classes.moreProductsButton} variant="outlined" onClick={() => setHasMoreProducts(true)}>
                <Box p={1} fontWeight="fontWeightBold" fontSize={12}>More products</Box>
              </Button>
            </Collapse>
          </Box>
        </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={hasCheckout} onChange={e => setHasCheckout(!hasCheckout)}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2b-content"
            id="panel2b-header"
        >
          <Typography className={classes.heading}>Checkout</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box className={classes.layersSelection}>
            <Grid container className={classes.priceTable}>
              <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>Project Reference</Box></Grid>
              <Grid item xs={9}><TextField id="project_reference" value={projectReference} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.projectRefText} onChange={handleProjectReferenceChange} required></TextField></Grid>
              <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>PO Number</Box></Grid>
              <Grid item xs={9}><TextField id="ponumber" value={poNumber} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.poText} onChange={handlePONumberChange}></TextField></Grid>
              { hasPRError ? (<Grid item xs={12}><Box className={classes.errorTxt} fontSize={11}>Project Reference is required</Box></Grid>) : ( '' )}
              { hasPriceError ? (<Grid item xs={12}><Box className={classes.errorTxt} fontSize={11}>Pricing error detected!, Please reset settings</Box></Grid>) : ( '' )}
            </Grid>
            <Divider />
            <Grid container className={classes.priceTable}>
              <Grid item xs={8}><Box className={classes.priceLabel} fontSize={12}>Price:</Box></Grid>
              <Grid item xs={1}><Box className={classes.priceLabel} fontSize={12}>£</Box></Grid>
              <Grid item xs={3}><Box className={classes.priceLabel} alignItems="right" fontSize={12}>{price}</Box></Grid>
              <Grid item xs={8}><Box className={classes.priceLabel} fontSize={12}>VAT:</Box></Grid>
              <Grid item xs={1}><Box className={classes.priceLabel} fontSize={12}>£</Box></Grid>
              <Grid item xs={3}><Box className={classes.priceLabel} alignItems="right" fontSize={12}>{vat}</Box></Grid>
              <Grid item xs={8}><Box className={classes.priceLabel} fontWeight="fontWeightBold" fontSize={12}>Total:</Box></Grid>
              <Grid item xs={1}><Box className={classes.priceLabel} fontWeight="fontWeightBold" fontSize={12}>£</Box></Grid>
              <Grid item xs={3}><Box className={classes.priceLabel} fontWeight="fontWeightBold" alignItems="right" fontSize={12}>{total}</Box></Grid>
            </Grid>
            <Divider />
            <Box className={classes.priceLabel} fontSize={12}>By clicking 'Purchase' you are agreeing to our <a href='https://www.mapdata.uk/terms' target='_blank' rel='noopener noreferrer' aria-label="Mapdata.uk terms and conditions">Terms and conditions</a></Box>
            <HtmlTooltip title={<React.Fragment>{purchaseTooltip}</React.Fragment>}>
              <span><Button className={classes.purchaseButton} disabled={purchaseDisabled} onClick={handlePurchase}>
                <Box p={1} fontWeight="fontWeightBold" fontSize={12}>Purchase</Box>
              </Button></span>
            </HtmlTooltip>
            <Button className={classes.cancelButton} onClick={cancelPurchase}>
              <Box fontWeight="fontWeightBold" fontSize={12}>Cancel</Box>
            </Button>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion disabled={downloaddisabled} expanded={hasDownload} onChange={e => setHasDownload(!hasDownload)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2c-content"
          id="panel2c-header"
        >
          <Typography className={classes.heading}>Download</Typography>
        </AccordionSummary>
        <AccordionDetails>
            {isProcess ? ( 
                <Button className={classes.downloadButton} variant="contained" disabled>
                    <Box p={1} display="flex" ><ReactLoading className={classes.loadingImg} type={'spin'} color={'#F6A036'} height={16} width={16}/></Box><Box p={1} fontWeight="fontWeightBold" fontSize={12}>Processing</Box>
                </Button>
            ) : ( 
                <Button className={classes.downloadButton} variant="contained" onClick={handleFileDownload} >
                    <Box p={1} display="flex" ><GetAppIcon className={classes.downloadIcon} /></Box><Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Download</Box>
                </Button>
            )}
            <Button className={classes.closeMenuButton} variant="contained" onClick={handleCloseDownload} >
                <Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Close</Box>
            </Button>
            <Box className={classes.priceLabel} fontSize={16}>
              {hasDownloadError && (
                <Typography color="error">
                  Something is not right with your download. Please contact support on support@mapdata.uk and let us know.
                </Typography>
              )}
            </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}